module.exports = __webpack_public_path__ + "img/image-6.1819d505.svg";